<template>
  <div class="pb-6">
    <b-loading v-if="loading" />
    <template v-else>
      <store-selector
        v-if="canSelectStore"
        v-model="menu"
        :origin-menu-id="originMenuId"
      />
      <order-detail
        v-else
        :allow-edit-type="allowEditType"
        :reselect-store="reselectStore"
        :menu="menu"
        :title="title"
        :view-mode="viewMode"
        @prev-step="prevStep"
      />
    </template>
  </div>
</template>

<script>
import OrderConfig from './OrderConfig';

export default OrderConfig;
</script>

<style lang="scss" scoped>
@import "./OrderConfig";
</style>
